import { render, staticRenderFns } from "./CreateAccountConfirmd.vue?vue&type=template&id=442b6c7a&scoped=true"
import script from "./CreateAccountConfirmd.vue?vue&type=script&lang=js"
export * from "./CreateAccountConfirmd.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountConfirmd.vue?vue&type=style&index=0&id=442b6c7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b6c7a",
  null
  
)

export default component.exports